import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class InfoClienteService {
  private infoClienteBehaviorSubject: BehaviorSubject<any> =
    new BehaviorSubject(null);

  constructor() {}

  getInfoClienteBehaviorSubject(): BehaviorSubject<any> {
    return this.infoClienteBehaviorSubject;
  }

  setInfoClienteBehaviorSubject(value: any) {
    this.infoClienteBehaviorSubject.next(value);
  }
}
